<script>
import { Howl } from "howler";
import AudioPlayerControls from "./AudioPlayerControls.vue";

export default {
  name: 'AudioPlayer',
  components: {
    AudioPlayerControls
  },
  props: {
    currentTime: Number,
    currentTrack: Object,
    isPlaying: Boolean,
  },
  data: () => {
    return {
      audioIsInit: false,
      audio: null,
      playerTime: 0,
      isScrubbing: false,
    };
  },
  watch: {
    currentTrack(newVal) {
      if (this.audioIsInit) {
        this.audioPause();
        this.initAudio(newVal);
        this.audioPlay();
      }
    },
    isPlaying(newVal, oldVal) {
      if (newVal !== oldVal && this.audio) {
        if (newVal)
          this.audioPlay();
        else
          this.audioPause();
      }
    },
    currentTime(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!this.isScrubbing) {
          this.audioSetTime(newVal)
        }
      }
    },
  },
  mounted() {
    this.initAudio(this.currentTrack);
    this.audioOnTimeUpdate();
  },
  methods: {
    initAudio(track) {
      this.audioIsInit = false;

      if (this.audio) {
        this.audio.unload();
      }
      
      this.audio = new Howl({
        src: [track.streamurl],
        ext: ['mp3'],
        html5: true
      });

    },
    audioOnTimeUpdate() {
      let newTime = this.playerTime;

      if (this.audioIsInit) {
        let pos = this.audio.seek();
        if (!isNaN(pos)) {
          newTime = parseInt(pos);
        }
      }

      if (this.playerTime !== newTime) {
        // don't update anything while scrubbing
        if (!this.isScrubbing) {
          this.$emit('timeUpdated', newTime);
          this.playerTime = newTime;
        }
      }

      // window.requestAnimationFrame(() => this.audioOnTimeUpdate());
      window.setTimeout(() => this.audioOnTimeUpdate(), 50);
    },
    audioPlay() {
      this.audioIsInit = true;
      this.audio.play();
      this.audio.seek(this.playerTime);
      this.$emit('playerStarted');
    },
    audioPause() {
      this.audio.pause();
      this.$emit('playerPaused');
    },
    onScrubbing(value) {
      this.isScrubbing = value;
    },
    audioSetTime(newTime) {
      // while scrubbing update time directly
      if (this.isScrubbing) {
        this.audio.seek(newTime);
        this.$emit('timeUpdated', newTime);
        this.playerTime = newTime;
      } 
      // time update on playback
      else if (this.playerTime !== newTime) {
        if (this.audioIsInit) {
          this.audio.seek(newTime);
        } else {
          this.$emit('timeUpdated', newTime);
        }
      }
    }
  },
};
</script>

<template>
  <div class="audio-player">
    <audio-player-controls 
        v-on:timeupdate="audioSetTime" 
        v-on:play="audioPlay" 
        v-on:pause="audioPause" 
        v-on:scrubbing="onScrubbing" 
        v-bind:current-time="playerTime"
        v-bind:trackSlug="currentTrack.slug"
        v-bind:hotspots="currentTrack.hotspots"
        v-bind:isPlaying="isPlaying">
    </audio-player-controls>
  </div>
</template>

<style scoped lang="scss">
@import "../assets/styles/variables";

.audio-player {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 170px;
}
</style>
